import React, { useEffect, useState } from "react"
import { GetTitleAndMetaTags } from "../../Code/Data"
import { Helmet } from "react-helmet-async"
import PrerenderManager from "../../Code/PrerenderManager"

export default function TitleAndMetaTags({ pageName, title, description, keywords, robots, schema }) {
  const [pageTitle, setTitle] = useState(title || "CharityChoice Donation Gift Card - Birthday, Thank you, Mother's Day, Valentine's Day, Anniversary")
  const [pageKeywords, setKeywords] = useState(keywords || "")
  const [pageDescription, setDescription] = useState(description || "The original charity gift card, corporate 'giving back' for over 2500 carefully vetted charities (Official Donation Site of the Red Cross).")
  const [pageRobots, setRobots] = useState(robots || "index, follow")

  useEffect(() => {
    // Declare that this component needs to wait for metadata
    PrerenderManager.requireOperation('metadata');

    async function fetchData() {
      const { PageTitle, Keywords, Description, Robots } = await GetTitleAndMetaTags(pageName)
      setTitle(PageTitle || pageTitle)
      setKeywords(Keywords || pageKeywords)
      setDescription(Description || pageDescription)
      setRobots(Robots || pageRobots)

    }

    if (pageName) {
      fetchData()
    } else {
      // No API call needed, metadata is ready immediately
      // Will be handled by Helmet onChangeClientState
    }
  }, [])

  const handleHelmetChange = () => {
    // Run on next tick after Helmet commits head changes.
    setTimeout(() => PrerenderManager.markReady('metadata'), 0);
  }

  return (
    <Helmet onChangeClientState={handleHelmetChange} defer={false}>
      {!!pageTitle && <title>{pageTitle}</title>}
      {!!pageKeywords && <meta name="keywords" content={pageKeywords} />}
      {!!pageDescription && <meta name="description" content={pageDescription} />}
      {!!pageRobots && <meta name="robots" content={pageRobots} />}
      {!!schema && (
        <script type="application/ld+json">
          {typeof schema === "string" ? schema : JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  )
}
